import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=62e7a264&scoped=true&"
import script from "./MyProjects.vue?vue&type=script&lang=js&"
export * from "./MyProjects.vue?vue&type=script&lang=js&"
import style0 from "./MyProjects.vue?vue&type=style&index=0&id=62e7a264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7a264",
  null
  
)

export default component.exports